import { render } from "./FloatingNotification.vue?vue&type=template&id=3515f6b7&scoped=true"
import script from "./FloatingNotification.vue?vue&type=script&lang=js"
export * from "./FloatingNotification.vue?vue&type=script&lang=js"

import "./FloatingNotification.vue?vue&type=style&index=0&id=3515f6b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3515f6b7"]])

export default __exports__